module.exports = __webpack_public_path__ + "img/2013-2.d05c61d0.jpeg";